import React from 'react';
import { Avatar, CardAvatar, Typography } from '@parkschannel/ui';

export interface TeamTileProps {
  src?: string;
  avatar?: React.ReactNode;
  name: string;
  position?: string;
  onClick?: () => void;
}

export const TeamTile: React.FC<TeamTileProps> = ({
  src,
  position,
  name,
  avatar,
  onClick,
}) => {
  return (
    <article
      onClick={onClick}
      className="w-full h-full bg-white drop-shadow p-4 rounded-2xl grid grid-cols-[min-content_1fr] items-center gap-4 cursor-pointer"
    >
      <CardAvatar size="xl">
        {avatar || (
          <Avatar src={src} size={'xl'} className={'drop-shadow-xl'} />
        )}
      </CardAvatar>

      <div>
        <Typography
          component="h4"
          variant="h6"
          className="mb-1 text-neutral-900"
        >
          {name}
        </Typography>

        <p className="text-xs leading-[18px] text-neutral-500">{position}</p>
      </div>
    </article>
  );
};
